import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useCallback } from 'react';

export default function useLogFrontendUserEventGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, VariablesGq>(gqTag);

  return useCallback(
    (command: CommandGq) =>
      mutation({ variables: { command } }).then(
        (result) => result.data.users.logFrontendUserEvent.success
      ),
    []
  );
}

const gqTag = gql`
  mutation LogFrontendUserEvent($command: LogFrontendUserEventCommand!) {
    users {
      logFrontendUserEvent(command: $command) {
        success
      }
    }
  }
`;

interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  projectId?: number;
  event: FrontendUserEventGq;
}

interface ResponseGq {
  users: {
    logFrontendUserEvent: {
      success: boolean;
    };
  };
}

export enum FrontendUserEventGq {
  VISIT_QUICK_SEARCH = 'VISIT_QUICK_SEARCH',
  VISIT_PROJECT = 'VISIT_PROJECT',
  VISIT_PROJECT_SERP = 'VISIT_PROJECT_SERP',
  VISIT_PROJECT_GOOGLE_ADS_REQUEST_PAGE = 'VISIT_PROJECT_GOOGLE_ADS_REQUEST_PAGE',
  VISIT_PROJECT_COLLECT_PAGE = 'VISIT_PROJECT_COLLECT_PAGE',
  VISIT_PROJECT_PROGRESS_PAGE = 'VISIT_PROJECT_PROGRESS_PAGE',
  VISIT_PROJECT_ANALYSIS_PAGE = 'VISIT_PROJECT_ANALYSIS_PAGE',
  VISIT_PROJECT_SETTINGS_PAGE = 'VISIT_PROJECT_SETTINGS_PAGE',
  VISIT_MULTI_PROJECT_PAGE = 'VISIT_MULTI_PROJECT_PAGE',
  TABLE_QUICK_ADD_COLUMN = 'TABLE_QUICK_ADD_COLUMN',
  TABLE_QUICK_HIDE_COLUMN = 'TABLE_QUICK_HIDE_COLUMN',
  TABLE_QUICK_RESIZE_COLUMN = 'TABLE_QUICK_RESIZE_COLUMN',
  TABLE_SLOW_ADD_COLUMN = 'TABLE_SLOW_ADD_COLUMN',
  TABLE_SLOW_HIDE_COLUMN = 'TABLE_SLOW_HIDE_COLUMN',
  TABLE_SLOW_RESIZE_COLUMN = 'TABLE_SLOW_RESIZE_COLUMN',
}
